export class AlarmAdditionalData {
    key!: string;
    value!: string;
}
